<div class="container-fluid g-0 m-0">
    <div class="row g-0 m-0 d-flex pt-5 align-items-center">
        <div class="col-md-1 d-flex pe-4 justify-content-end">
            <div class="button-back pb-3" [routerLink]="['/utilities/all']">
                <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
            </div>
        </div>
        <div class="col-md-11">
            <h2 class="col pb-2 m-0 title">{{ "ADD_UTILITY" | translate }}</h2>
            <p class="col subtitle">{{ "UTILITY_SETUP_SUBTITLE" | translate }}</p>
        </div>
    </div>

    <form #crudform="ngForm" (ngSubmit)="onSubmit()">
        <!-- NAME -->
        <div class="form-item">
            <label class="form-label" for="name">{{ "NAME" | translate }}*</label>
            <div class="form-input">
                <input id="name" [(ngModel)]="data.name" #name="ngModel" name="name" type="text"
                    pattern="^[A-Za-zÀ-ž' -]+$" required />
                <div *ngIf="name.invalid && (name.dirty || name.touched)">
                    <small class="text-danger" *ngIf="name.errors?.['required']">
                        {{ "NAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                    <small class="text-danger" *ngIf="name.errors?.['pattern']">
                        {{ 'ALLOWED_LETTERS_SPACES_APOSTROPHES' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- ACRONYM -->
        <div class="form-item">
            <label class="form-label" for="acronym">{{ "ACRONYM" | translate }}*</label>
            <div class="form-input">
                <input id="acronym" [(ngModel)]="data.acronym" #acronym="ngModel" name="acronym" type="text" required
                    minlength="2" maxlength="15" pattern="^[a-zA-Z0-9]+$" [disabled]="data.id != null"/>
                <div *ngIf="acronym.invalid && (acronym.dirty || acronym.touched)">
                    <small class="text-danger" *ngIf="acronym.errors?.['required']">
                        {{ "ACRONYM" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>

                    <small class="text-danger" *ngIf="acronym.errors?.['minlength'] || acronym.errors?.['maxlength']">
                        {{ "ACRONYM_LENGTH_2_15" | translate }}
                    </small>

                    <small class="text-danger" *ngIf="acronym.errors?.['pattern']">
                        {{ 'ALLOWED_LETTERS_NUMBERS' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <div class="horizontal-line"></div>

        <!-- CONTACT PERSON FIRST NAME -->
        <div class="form-item">
            <label class="form-label" for="firstName">{{ "FIRSTNAME" | translate }}*</label>
            <div class="form-input">
                <input id="firstName" [(ngModel)]="data.contactPersonFirstName" #firstName="ngModel"
                    name="contactPersonFirstName" type="text" required [disabled]="data.id != null" />
                <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">
                    <small class="text-danger" *ngIf="firstName.errors?.['required']">
                        {{ "FIRSTNAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- CONTACT PERSON LAST NAME -->
        <div class="form-item">
            <label class="form-label" for="lastName">{{ "LASTNAME" | translate }}*</label>
            <div class="form-input">
                <input id="lastName" [(ngModel)]="data.contactPersonLastName" #lastName="ngModel"
                    name="contactPersonLastName" type="text" required [disabled]="data.id != null" />
                <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)">
                    <small class="text-danger" *ngIf="lastName.errors?.['required']">
                        {{ "LASTNAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- CONTACT PERSON EMAIL -->
        <div class="form-item">
            <label class="form-label" for="email">{{ "EMAIL" | translate }}*</label>
            <div class="form-input">
                <input id="email" [(ngModel)]="data.contactPersonEmail" #email="ngModel" name="contactPersonEmail"
                    type="text" required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    [disabled]="data.id != null" />
                <div *ngIf="email.invalid && (email.dirty || email.touched)">
                    <small class="text-danger" *ngIf="email.errors?.['required']">
                        {{ "EMAIL" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                    <small class="text-danger" *ngIf="email.errors?.['pattern']">
                        {{ 'DEVICES_INVALID' | translate }} {{ 'EMAIL' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- CONTACT PERSON PHONE NUMBER -->
        <div class="form-item">
            <label class="form-label" for="phoneNumber">{{ "PHONE_NUMBER" | translate }}</label>
            <div class="form-input">
                <input id="contactPersonPhoneNumber" [(ngModel)]="data.contactPersonPhoneNumber" #phoneNumber="ngModel"
                    name="contactPersonPhoneNumber" type="text" pattern="^\+?[0-9\s\-()]{7,15}$"
                    [disabled]="data.id != null" />
                <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)">
                    <small class="text-danger" *ngIf="phoneNumber.errors?.['pattern']">
                        {{ 'DEVICES_INVALID' | translate }} {{ 'PHONE_NUMBER' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <div class="horizontal-line"></div>

        <!-- COUNTRY -->
        <div class="form-item">
            <label class="form-label" for="country">{{ "UTILITY_COUNTRY" | translate }}*</label>
            <div class="form-input">
                <select id="country" [(ngModel)]="data.country" #country="ngModel" name="country" required>
                    <option *ngFor="let c of countryDictionary" [value]="c">
                        {{ c }}
                    </option>
                </select>
                @if (data.country == null && (country.dirty || country.touched)) {
                <div class="validation-instruction">
                    {{ "DEVICESETUP_DATACOLLECTIONINTERVALSDESC" | translate }}
                </div>
                }
            </div>
        </div>

        <!-- TIME ZONE -->
        <div class="form-item">
            <label class="form-label" for="timeZone">{{ "TIMEZONE" | translate }}*</label>
            <div class="form-input">
                <select id="timeZone" name="timeZone" [(ngModel)]="data.timeZone" #timeZone="ngModel" required>
                    <option *ngFor="let zone of timezones" [value]="zone.value">
                        {{ zone.name }}
                    </option>
                </select>
                @if (data.timeZone == null && (timeZone.dirty || timeZone.touched)) {
                <div class="validation-instruction">
                    {{ "DEVICESETUP_DATACOLLECTIONINTERVALSDESC" | translate }}
                </div>
                }
            </div>
        </div>

        <!-- ADDRESS -->
        <div class="form-item">
            <label class="form-label" for="address">{{ "UTILITY_ADDRESS" | translate }}*</label>
            <div class="form-input">
                <input id="address" [(ngModel)]="data.address" #address="ngModel" name="address" type="text"
                    pattern="^[a-zA-Z0-9\s.,'’\-/#]{5,100}$" required />
                <div *ngIf="address.invalid && (address.dirty || address.touched)">
                    <small class="text-danger" *ngIf="address.errors?.['required']">
                        {{ "UTILITY_ADDRESS" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                    <small class="text-danger" *ngIf="address.errors?.['pattern']">
                        {{ 'DEVICES_INVALID' | translate }} {{ 'UTILITY_ADDRESS' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- WEBSITE ADDRESS -->
        <div class="form-item">
            <label class="form-label" for="websiteAddress">{{ "WEBSITE_ADDRESS" | translate }}*</label>
            <div class="form-input">
                <input id="websiteAddress" [(ngModel)]="data.websiteAddress" #websiteAddress="ngModel"
                    name="websiteAddress" type="text"
                    pattern="^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$" required />
                <div *ngIf="websiteAddress.invalid && (websiteAddress.dirty || websiteAddress.touched)">
                    <small class="text-danger" *ngIf="websiteAddress.errors?.['required']">
                        {{ "WEBSITE_ADDRESS" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}
                    </small>
                    <small class="text-danger" *ngIf="websiteAddress.errors?.['pattern']">
                        {{ 'DEVICES_INVALID' | translate }} {{ 'WEBSITE_ADDRESS' | translate }}
                    </small>
                </div>
            </div>
        </div>

        <!-- LOGO -->
        <div class="form-item">
            <label class="form-label" for="logoPath">Logo</label>
            <div class="form-input">
                <img *ngIf="data.logoPath" src="data:image/png;base64,{{ data.logoPath }}" alt="User"
                    class="utility-logo" />
                <span *ngIf="!data.logoPath" class="no-logo">/</span>
            </div>
        </div>

        <div class="row p-2 mt-4 mb-4 rounded upload-section align-items-center" appDragAndDrop
            (click)="onFileSelected($event)">
            <input #fileInput type="file" (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png" />
            <svg-icon alt="Upload" class="d-flex justify-content-center"
                src="assets/settings/upload-arrow.svg"></svg-icon>
            <!-- <img
                *ngIf="imagePreview"
                [src]="imagePreview"
                alt="Preview"
                class="d-flex justify-content-center mt-2"
                width="30"
                height="30"
            /> -->
            <span class="d-flex justify-content-center">
                {{ 'DRAGANDDROP_LOGO' | translate}}
            </span>
        </div>

        <!-- SUBMIT -->
        <div class="form-item-button">
            <button class="button-submit" [disabled]="crudform.invalid" type="submit">
                {{ "SAVE" | translate }}
            </button>
            <div [routerLink]="['/utilities/all']">
                <button class="button-cancel" type="button">
                    {{ "CANCEL" | translate }}
                </button>
            </div>
        </div>
    </form>
</div>